import React, { useEffect, useRef, useState } from "react";
import { MessageCircle } from "lucide-react";
import { useHelpContact, helpWaUrl } from "@/lib/helpContact";

const TAPPABLE = "a[href], button, [role='button'], input, select, textarea, label";

// Mobile only: step aside while the button sits on top of a card/link/button, so the tap reaches the content.
function useStepAside(ref) {
  const [aside, setAside] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia("(max-width: 639px)");
    let raf = 0;
    const check = () => {
      raf = 0;
      const el = ref.current;
      if (!el || !mq.matches) { setAside(false); return; }
      const r = el.getBoundingClientRect();
      const pts = [[r.left + r.width / 2, r.top + r.height / 2], [r.left + 6, r.top + 6], [r.right - 6, r.top + 6], [r.left + 6, r.bottom - 6], [r.right - 6, r.bottom - 6]];
      setAside(pts.some(([x, y]) => {
        const under = document.elementsFromPoint(x, y).find((n) => !el.contains(n));
        return !!under?.closest?.(TAPPABLE);
      }));
    };
    const queue = () => { if (!raf) raf = requestAnimationFrame(check); };
    window.addEventListener("scroll", queue, { passive: true });
    window.addEventListener("resize", queue);
    const timer = setInterval(queue, 800);
    queue();
    return () => { window.removeEventListener("scroll", queue); window.removeEventListener("resize", queue); clearInterval(timer); if (raf) cancelAnimationFrame(raf); };
  }, [ref]);
  return aside;
}

export default function WhatsAppHelp() {
  const ref = useRef(null);
  const aside = useStepAside(ref);
  const wa = helpWaUrl(useHelpContact());
  if (!wa) return null;
  return (
    <a
      ref={ref}
      href={wa}
      target="_blank"
      rel="noopener noreferrer"
      title="Help chahiye?"
      aria-label="Help chahiye? WhatsApp par baat karein"
      aria-hidden={aside || undefined}
      tabIndex={aside ? -1 : undefined}
      className={`group fixed bottom-5 end-5 z-40 w-12 h-12 rounded-full bg-[#25D366] hover:bg-[#1ebe5a] text-white shadow-lg shadow-black/20 flex items-center justify-center transition-[opacity,transform] duration-200 hover:scale-105 ${aside ? "opacity-0 pointer-events-none scale-75" : "opacity-100"}`}
      data-testid="floating-whatsapp-btn"
      data-aside={aside}
    >
      <MessageCircle className="w-6 h-6" />
      <span className="pointer-events-none absolute end-full me-2 whitespace-nowrap rounded-lg bg-slate-900 text-white text-xs font-semibold px-2.5 py-1 opacity-0 group-hover:opacity-100 transition-opacity" data-testid="floating-whatsapp-tooltip">
        Help chahiye?
      </span>
    </a>
  );
}
